<template>
  <div class="messenger form-group--border">
    <div class="row">
      <div class="col-4 messenger-dialogs scrollable-content" v-on:scroll="scrollDialogs">
        <div class="input-group mb-2" v-if="!filter.patientId && !filter.journalImarOrganizationId">
          <input
            type="text"
            v-model="dialogRequest.search"
            placeholder="Поиск по ФИО..."
            @input="onSearchInput"
            class="form-control"
          />
          <div @click="clearSearch" 
            v-if="dialogRequest.search" 
            class="cross"><icon-component name="cross"/></div>
        </div>
        <div
          v-for="dialog in dialogs.items"
          :key="dialog.id"
          :class="{
            'messenger-dialog_block': true,
            hilite: dialog.id === currentDialog.id
          }"
          @click="loadMessages(dialog, true)"
        >
          <h5
            class="messenger-dialog_title"
          >
            {{ dialog.title }}
            <template v-if="dialog.unreadMessageCount">
              ({{ dialog.unreadMessageCount }})</template
            >
          </h5>
          <div class="messnger-dialog_info" v-if="hasDialogInfo(dialog)">
            <template v-if="!!dialog.patientFio">
              <div>{{ dialog.patientFio }}</div>
            </template>
            <template v-if="!!dialog.organizationId">
              <a
                href="javascript:"
                @click="openOrgCard(dialog.organizationId)"
                >{{ dialog.organizationName }}</a
              >
            </template>
            <div>{{ dialog.period }}</div>
            <div>{{ dialog.schedule }}</div>
            <span
              v-if="dialog.dialogType !== 1"
              :class="{ inactive: !dialog.isActive }"
              >{{ dialog.isActive ? "Активен" : "Неактивен" }}</span
            >
          </div>
        </div>
        <!-- Если диалогов нет -->
        <div v-if="dialogs.items.length === 0 && !filter.patientId && !filter.journalImarOrganizationId" class="no-dialogs text-center py-3">
          Диалоги не найдены
        </div>
      </div>
      <div class="col-8 messenger-textBlock">
        <template v-if="messages.items.length">
          <div
            class="messenger-messages scrollable-content"
            v-on:scroll="scrollMessages"
          >
            <div
              v-for="message in messages.items"
              :key="message.id"
              :class="{
                'messenger-message_block': true,
                unread: message.isNew
              }"
            >
              <div class="messenger-message-header">
                <div class="messenger-message-header-user">
                  <template v-if="!!message.fromUserId">
                    <a
                      href="javascript:"
                      @click="openUserCard(message.fromUserId)"
                      >{{ message.fromUserName }}</a
                    >
                  </template>
                  <template v-else>
                    <span>{{ message.fromUserName }}</span>
                  </template>
                </div>
                <div class="messenger-message-header-date">
                  {{ $momentFormat(message.created, "DD.MM.YYYY HH:mm") }}
                </div>
              </div>
              <div class="messnger-message_text">
                {{ message.text }}
              </div>
              <div class="d-flex flex-wrap gap-2" v-if="message.files">
                <div v-for="file in message.files" :key="file.id">
                  <a href="#" @click.prevent="downloadFile(file)" class="file" title="скачать файл">{{ file.originalName }}</a>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <EmptyListMessage />
        </template>
        <div
          v-if="
            currentDialog &&
              currentDialog.dialogType !== 1 &&
              currentDialog.isActive
          "
        >
          <textarea
            v-model="messageText"
            class="form-control"
            rows="3"
            v-on:keyup.enter="postMessageByKey"
          ></textarea>
          <div class="messenger__messages-files-area mt-2" v-if="files"> 
              <div class="file-wrapper d-flex gap-1" v-for="(file, index) in files" :key="index">
                {{ file.originalName }}, {{ Math.ceil(file.fileSize / 1024) }} Кб
                <a href="javascript:" @click="removeFile(index)" title="удалить файл">
                  <i class="fa fa-trash file-delete"></i>
                </a>
              </div>
            </div>
          <div class="d-flex justify-content-between mt-2">
            <label class="upload-btn" for="file">
                <i class="fa fa-upload" style="color:#fff"></i> Прикрепить файл
            </label>
            <input
                class="d-none"
                id="file"
                type="file"
                multiple="multiple"
                ref="fileInput"
                v-on:change="uploadFile($event)"
              />

            <button-component
              kind="primary"
              :disabled="!messageText && !(files && files.length > 0)"
              @click="postMessage"
              >Отправить</button-component
            >
            
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="modals">
    <modal-component
      v-if="modals.userProfile.show"
      title="Профиль"
      size-class=""
      @close="modals.userProfile.show = false"
    >
      <user-profile :user-id="modals.userProfile.userId" />
    </modal-component>
    <modal-component
      v-if="modals.orgProfile.show"
      title="Организация"
      size-class=""
      @close="modals.orgProfile.show = false"
    >
      <organization-profile
        :organization-id="modals.orgProfile.organizationId"
      />
    </modal-component>
  </section>
</template>

<script>
import Api from "@/modules/messenger/api/index";
import EmptyListMessage from "@/common/components/EmptyListMessage";
import ButtonComponent from "@/common/ui/ButtonComponent";
import Constants from "@/common/constants";
import ModalComponent from "../../../common/ui/ModalComponent";
import UserProfile from "./UserProfile";
import OrganizationProfile from "./OrganizationProfile";
import IconComponent from "@/common/ui/IconComponent";
import FileApi from "@/modules/file/api";
import Utils from "@/common/utils";

export default {
  name: "MessengerForm",
  components: {
    OrganizationProfile,
    UserProfile,
    ModalComponent,
    ButtonComponent,
    EmptyListMessage,
    IconComponent
  },
  props: {
    filter: {
      dialogType: [Number, Array],
      patientId: Number,
      journalImarOrganizationId: Number
    }
  },
  data() {
    return {
      dialogRequest: {
        pageNumber: 1,
        pageSize: 5,
        search: ""
      },
      messageRequest: {
        pageNumber: 1,
        pageSize: 10
      },
      dialogs: {
        itemsTotal: 0,
        items: []
      },
      messages: {
        itemsTotal: 0,
        items: []
      },
      currentDialog: null,
      messageText: null,
      files: [],
      scrolling: false,
      topScrollThreshold: 50,
      modals: {
        userProfile: {
          userId: null,
          show: false
        },
        orgProfile: {
          organizationId: null,
          show: false
        }
      },
      searchDebounceTimer: null
    };
  },
  created() {
    this.loadDialogs();
  },
  methods: {
    uploadFile(e) {
        const files = e.target.files;
        if (this.files.length + files.length > Constants.messengerFileLimit) {
          Constants.alert.fire(
            'Ошибка',
            `К сообщению можно прикрепить не более ${Constants.messengerFileLimit} файлов.`,
            'error',
          );
          return;
        }
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          if (file.size > Constants.messengerFileMaxSize) {
            Constants.alert.fire(
              'Ошибка',
              `К сообщению можно прикрепить файл размером не более ${Constants.messengerFileMaxSize / 1048576} МБ.`,
              'error',
            );
            return;
          }
          FileApi.upload(file).then((response) => {
            this.files.push(response.data);
          });
        }
        this.$refs.fileInput.value = null;
      },
      removeFile(index) {
        this.files.splice(index, 1);
      },
    downloadFile(file) {
      Utils.downloadFileByUid(file.guid, file.originalName);
    },
    onSearchInput() {
      // очищаем предыдущий таймер
      clearTimeout(this.searchDebounceTimer);

      // ставим новый таймер, например 400 мс
      this.searchDebounceTimer = setTimeout(() => {
        this.dialogRequest.pageNumber = 1; // сбрасываем на первую страницу
        this.loadDialogs(); // вызываем загрузку
      }, 400);
    },
    clearSearch() {
      this.dialogRequest.search = ""; // очищаем поле
      this.dialogRequest.pageNumber = 1; // сбрасываем страницу
      this.loadDialogs(); // загружаем все диалоги без фильтра
    },
    hasDialogInfo(dialog) {
      return Boolean(
        dialog.patientFio ||
        dialog.organizationId ||
        dialog.period ||
        dialog.schedule //||
        //(dialog.dialogType !== 1) // если нужен вывод span с активностью
      );
    },
    loadDialogs() {
      const request = Object.assign(this.dialogRequest, this.filter);
      if (Array.isArray(request.dialogType)) {
        request.dialogTypes = request.dialogType;
        delete request.dialogType;
      }
      Api.loadDialogs(request).then(response => {
        this.dialogs = response.data;
        if (this.dialogs.items.length) {
          this.loadMessages(this.dialogs.items[0]);
          this.updateUnreadCounters();
        }

        // Проверяем, влез ли контент
        this.$nextTick(() => this.ensureScrollableFilled());
      });
    },

    async loadNextDialogs() {
      if (this.scrolling) return;

      const count = this.dialogs.items.length;
      if (count >= this.dialogs.itemsTotal) return; // все загружены

      this.scrolling = true;
      this.dialogRequest.pageNumber += 1;

      const request = Object.assign({}, this.dialogRequest, this.filter);
      if (Array.isArray(request.dialogType)) {
        request.dialogTypes = request.dialogType;
        delete request.dialogType;
      }

      try {
        const response = await Api.loadDialogs(request);
        this.dialogs.items = this.dialogs.items.concat(response.data.items);
        this.updateUnreadCounters();
      } finally {
        this.scrolling = false;
        // Проверим снова — возможно, всё ещё не хватает контента
        this.$nextTick(() => this.ensureScrollableFilled());
      }
    },

    ensureScrollableFilled() {
      const container = $(".messenger-dialogs")[0];
      if (!container) return;
      const hasScroll = container.scrollHeight > container.clientHeight + 5;

      if (!hasScroll && this.dialogs.items.length < this.dialogs.itemsTotal) {
        this.loadNextDialogs();
      }
    },

    scrollDialogs(e) {
      const el = e.target;
      if (el.scrollHeight - el.scrollTop <= el.clientHeight + 5) {
        this.loadNextDialogs();
      }

      // const el = $(e.target);
      // const top = el.scrollTop();
      // if (e.target.scrollHeight - top === e.target.clientHeight) {
      //   if (!this.scrolling) {
      //     const count = this.dialogs.items.length;
      //     if (count < this.dialogs.itemsTotal) {
      //       this.scrolling = true;
      //       this.dialogRequest.pageNumber = this.dialogRequest.pageNumber + 1;
      //       const request = Object.assign(this.dialogRequest, this.filter);
      //       if (Array.isArray(request.dialogType)) {
      //         request.dialogTypes = request.dialogType;
      //         delete request.dialogType;
      //       }
      //       Api.loadDialogs(request)
      //         .then(response => {
      //           this.dialogs.items = this.dialogs.items.concat(
      //             response.data.items
      //           );
      //           this.updateUnreadCounters();
      //           this.scrolling = false;
      //         })
      //         .catch(() => {
      //           this.scrolling = false;
      //         });
      //     }
      //   }
      // }
    },
    updateUnreadCounters() {
      this.dialogs.items.forEach(dlg => {
        Api.getUnreadMessageCount(dlg.id).then(response => {
          dlg.unreadMessageCount = response.data;
        });
      });
    },
    loadMessages(dialog, reset) {
      this.currentDialog = dialog;
      if (reset) {
        this.messageRequest.pageNumber = 1;
      }
      const request = Object.assign(this.messageRequest, {
        dialogId: dialog.id
      });
      Api.loadMessages(request).then(response => {
        this.messages = response.data;
        this.$nextTick(() => {
          const el = $(".messenger-messages.scrollable-content");
          el.scrollTop(el.prop("scrollHeight"));
        });
        this.readMessages();
      });
    },
    scrollMessages(e) {
      const el = $(e.target);
      if (el.scrollTop() < this.topScrollThreshold) {
        if (!this.scrolling) {
          const count = this.messages.items.length;
          if (count < this.messages.itemsTotal) {
            this.scrolling = true;
            this.messageRequest.pageNumber = this.messageRequest.pageNumber + 1;
            const request = Object.assign(this.messageRequest, {
              dialogId: this.currentDialog.id
            });
            Api.loadMessages(request)
              .then(response => {
                this.messages.items = response.data.items.concat(
                  this.messages.items
                );
                this.readMessages();
                this.scrolling = false;
              })
              .catch(() => {
                this.scrolling = false;
              });
          }
        }
      }
    },
    readMessages() {
      this.messages.items.forEach(msg => {
        if(msg.isNew) {
          Api.readMessage(msg.id).then((res) => {
            if(res && res.data && res.data.success === true) {
              setTimeout(() => {
                msg.isNew = false
              }, 5000)
            }
          });
        }
      });
    },
    openUserCard(id) {
      this.modals.userProfile.userId = id;
      this.modals.userProfile.show = true;
    },
    openOrgCard(id) {
      this.modals.orgProfile.organizationId = id;
      this.modals.orgProfile.show = true;
    },
    postMessage() {
      const data = {
        dialogId: this.currentDialog.id,
        text: this.messageText,
        files: this.files,
      };
      Api.postMessage(data)
        .then(response => {
          this.messageText = null;
          this.files = [];
          this.appendMessage(response.data);
        })
        .catch(() => {
          Constants.alert.fire(
            "Ошибка",
            "При отправке сообщения произошла ошибка. Попробуйте отправить его позже или обратитесь в техническую поддержу.",
            "error"
          );
        });
    },
    postMessageByKey(e) {
      if (e.ctrlKey) {
        this.postMessage();
      }
    },
    appendMessage(message) {
      this.messages.items.push(message);
      this.messages.itemsTotal++;
      this.$nextTick(() => {
        const el = $(".messenger-messages.scrollable-content");
        el.scrollTop(el.prop("scrollHeight"));
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.messenger {
  &.form-group--border {
    min-height: 640px;
  }
}
.scrollable-content {
  overflow-y: auto;
  max-height: 640px;
}
.messenger-dialog_block {
  border: solid 1px $gray-light1;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 16px;
  cursor:pointer;

  &:hover {
    background-color: $gray-light2;
  }

  .messenger-dialog_title {
    cursor: pointer;
    margin-bottom: 0;
  }
  &.hilite {
    background-color: $gray-light2;
  }
  .messnger-dialog_info {
    margin-top: 0.5rem;
    span {
      color: $green;
      &.inactive {
        color: $red-dark;
      }
    }
  }
}
.messenger-messages {
  border: solid 1px $gray-light1;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 16px;

  .messenger-message_block {
    border: solid 1px $gray-light1;
    background-color: $white-mist-bg;
    padding: 8px 16px;
    margin-bottom: 16px;

    transition: background-color 0.8s ease, border-color 0.8s ease;

    &.unread {
      background-color: $blue-light1;
    }

    .messenger-message-header {
      .messenger-message-header-date {
        font-weight: bold;
      }
    }
    .messnger-message_text {
      white-space: pre-line;
    }

    .messnger-message_files {
      display:flex;
      gap: 10px;
    }
  }
  &.scrollable-content {
    min-height: 460px;
    max-height: 460px;
  }
}
.float-right {
  float: right !important;
}


.input-group {
  position: relative;
  input {
    height: 100%;
  }
  .cross {
    z-index: 10;
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
    .icon {
      width: 10px;
      height: 10px;
    }
  }
}

    @media (max-width: 600px){
      .messenger{
        &-row{
          flex-wrap: wrap;
        }
        &-dialogs,
        &-textBlock{
          width: 100%;
        }
      }
      
    }

.upload-btn {
  margin: 0;
  display: block;
  padding: 14px 32px;
  border-radius: 32px;
  transition: all 0.2s ease;
  cursor: pointer;
  border: 1px solid transparent;
  box-sizing: border-box;
  font-weight: 600;
  color: $white;
    background-color: $green-light;
    border-color: $green-light;
    &:hover {
      color: $white;
      background-color: $green-dark;
      border-color: $green-dark;
    }
}

.file-delete:hover {
  color: $red;
}

@media (max-width: 1440px) {
  .upload-btn {
    // width: 100%;
    max-width: 100%;
    // justify-content: center;
    text-align: center;
    padding: 8px 16px;
    &.width-auto {
      width: auto;
    }
  }
}
</style>
